/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import { FancyAction } from 'src/app/common/fancy-firebase/base/FancyAction';
import { FancyActionableFirebase } from 'src/app/common/fancy-firebase/generics/FancyActionableFirebase';
import { RoleList } from 'src/app/common/fancy-firebase/services/factories';
import { Role } from '@touchplan/common';

export class RolesApi extends FancyActionableFirebase<Role, FancyAction, RoleList> {
	constructor(public data: RoleList) {
		super(data);
	}

	public addItem(initialData: object, idOverride?: string, persistImmediately = false) {
		const key = this.data.generateNewChildKey();
		const roleData = Object.assign({ roleId: key }, initialData);
		super.addItem(roleData, key, persistImmediately);
	}
}
